import './LogoSVG.css'; // CSS file for animations

import React from 'react';

export default function LogoLoader({ height = "150px", width = "120px", color = 'black',animationFrequency="infinite"}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 35 39"
      preserveAspectRatio="xMidYMid meet"
      className={animationFrequency === "infinite" ? "pulsating-logo":"pulsating-logo-finite"}
    >
      <path
        d="M8.27339 29.3779C12.7832 23.1957 14.7043 16.2715 16.3089 12.9323C17.1476 11.1869 17.9297 9.70631 16.6952 7.6927C15.5926 5.89438 15.4858 5.7726 15.2244 3.93549C15.2002 3.76505 14.9777 3.71343 14.8876 3.86007C9.6639 12.354 2.88563 24.9967 1.2953 27.939C-0.317421 30.9228 -0.0863221 33.3874 1.31636 33.8577C1.3246 33.8605 1.33326 33.8626 1.34183 33.8641C4.31251 34.3704 7.13356 30.9405 8.27339 29.3779Z"
        fill={color}
      />
      <path
        d="M24.9872 25.6409C22.9315 22.7624 19.6972 17.8081 17.4545 13.846C17.2506 13.4858 17.2766 13.0438 17.485 12.6862C20.4272 7.63673 14.7497 6.54864 16.4648 1.98147C16.6778 1.41441 17.2909 1.00236 17.828 1.28224C18.4182 1.58971 18.8521 2.28749 19.6715 3.58204C20.8593 5.4589 31.4377 23.7498 31.5085 23.8721C31.5106 23.8759 31.5097 23.8745 31.5116 23.8784C32.9878 26.9089 36.8782 34.1659 31.9215 34.194C29.3229 34.2088 26.7874 28.1617 24.9872 25.6409Z"
        fill={color}
      />
      <path
        d="M20.5094 25.5776C21.3212 25.1037 22.2005 25.1343 22.7795 25.2731C22.9472 25.3133 23.1218 25.1315 23.0427 24.9782C21.2014 21.4112 16.6868 19.6691 13.6057 23.3756C11.2321 26.2606 6.72965 36.0854 1.51043 34.6116C1.35138 34.5667 1.19984 34.728 1.27466 34.8753C2.61785 37.5209 4.8093 38.6585 7.49798 38.6432C14.3194 38.6046 15.2286 28.6608 20.5094 25.5776Z"
        fill={color}
      />
      <path
        d="M29.5141 34.2241C30.7268 35.3903 32.5711 35.5666 33.9617 34.58C34.1171 34.4698 34.3563 34.6182 34.2927 34.7977C33.2541 37.7295 31.0858 38.7536 28.4783 38.5339C23.6133 38.1238 22.9644 28.4808 17.6497 30.7214C17.4792 30.7933 17.2972 30.6061 17.3937 30.4482C19.2637 27.3884 22.3481 24.3337 25.2277 28.2702C26.6267 30.1829 27.9802 32.749 29.5141 34.2241Z"
        fill={color}
      />
    </svg>
  );
}

// old logo
// export default function LogoLoader({ height = 150, width = 120, color = "black",animationFrequency="infinite"}) {
//   return (
//     <div className="logo-container">
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         viewBox="0 0 375 375"
//         height={height}
//         width={width}
//         preserveAspectRatio="xMidYMid meet"
//         className={animationFrequency === "infinite" ? "pulsating-logo":"pulsating-logo-finite"}
//       >
//         <defs>
//           <clipPath id="clip1">
//             <path d="M 18.699219 277 L 262 277 L 262 339 L 18.699219 339 Z" />
//           </clipPath>
//           <clipPath id="clip2">
//             <path d="M 202 120 L 356.199219 120 L 356.199219 363.785156 L 202 363.785156 Z" />
//           </clipPath>
//           <clipPath id="clip3">
//             <path d="M 80 11.285156 L 246 11.285156 L 246 268 L 80 268 Z" />
//           </clipPath>
//         </defs>
//         <g clipPath="url(#clip1)">
//           <path
//             fill={color}
//             d="M 49.242188 277.503906 L 232.078125 277.503906 L 261.03125 338.199219 L 18.769531 338.199219 L 49.242188 277.503906"
//           />
//         </g>
//         <g clipPath="url(#clip2)">
//           <path
//             fill={color}
//             d="M 332.640625 311.992188 L 356.261719 363.71875 L 284.648438 363.71875 L 202.371094 190.601562 L 238.175781 120.25 L 332.640625 311.992188"
//           />
//         </g>
//         <g clipPath="url(#clip3)">
//           <path
//             fill={color}
//             d="M 165.039062 241.640625 L 152.851562 267.160156 L 80.476562 267.160156 L 210.75 11.28125 L 245.796875 83.007812 L 165.039062 241.640625"
//           />
//         </g>
//       </svg>
//     </div>
//   );
// }
